import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var HeartCircle = function HeartCircle(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: [/*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M12 22c5.5228 0 10-4.4772 10-10S17.5228 2 12 2 2 6.4772 2 12s4.4772 10 10 10"
    }), /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M11.9966 9.068c-.9997-1.1688-2.6667-1.4832-3.9193-.413s-1.4288 2.8595-.4452 4.1252c.63.8107 2.2435 2.314 3.3221 3.2902.3585.3243.5377.4865.7524.5516a1.024 1.024 0 0 0 .58 0c.2146-.0651.3939-.2273.7523-.5516 1.0787-.9762 2.6921-2.4795 3.3222-3.2902.9836-1.2657.8288-3.0663-.4453-4.1252s-2.9195-.7558-3.9192.413",
      clipRule: "evenodd"
    })]
  }));
};
export default HeartCircle;